import api from "../api/axios";

async function getIndicators(id) {
  const response = await api.get("/api/v1/indicators/" + id);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function updateIndicator(indicatorId, agreementId, indicatorData) {
  const response = await api.put("/api/v1/indicators/" + indicatorId, {
    status: indicatorData.status,
    name: indicatorData.name,
    description: indicatorData.description,
    agreement_id: agreementId,
  });
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function createIndicator(agreementId, indicatorData) {
  const response = await api.post("/api/v1/indicators", {
    status: indicatorData.status,
    name: indicatorData.name,
    description: indicatorData.description,
    agreement_id: agreementId,
  });

  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function updateIndicatorStatus(indicatorId, statusData) {
  const response = await api.put(
    "/api/v1/indicators/" + indicatorId + "/update_status",
    { status: statusData }
  );
  if (!response) {
    throw new Error(response.statusText);
    
  }

  return response;
}

async function deleteIndicator(indicatorId) {
  const response = await api.delete("/api/v1/indicators/" + indicatorId);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

export {
  getIndicators,
  updateIndicator,
  createIndicator,
  deleteIndicator,
  updateIndicatorStatus,
};
